<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      height="500"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :loading="loading"
      :columns="tableColumn"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="fabricStockCode"
      :checkboxConfig="{
        reserve: true,
        highlight: true,
        trigger: 'row',
        range: true,
      }"
      @checkbox-all="selectAllEvent"
      @checkbox-change="selectChangeEvent"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:tools>
        <span>{{ showSelectCount }}</span>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImgUrl="{ row }">
        <div v-viewer="{ movable: true }">
          <el-image
            :src="
              row.imageCode
                ? $osscdn(row.imageCode)
                : '/image/static/img/nopic.jpg'
            "
            style="width:100px; height:66px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 100px; height: 66px"
              />
            </div>
          </el-image>
        </div>
      </template>
      <template v-slot:fabricName="{ row }">
        <span>{{ row.fabricName }}</span>
        <br />
        <span>{{ row.fabricNameEn }}</span>
      </template>
      <template v-slot:fabricContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>
      <template v-slot:wid="{ row }">
        <span>{{ row.wid }} </span>
        <span>{{ row.widUnit }}</span>
      </template>
      <template v-slot:fabricWeight="{ row }">
        <span>{{ row.fabricWeight }} </span>
        <span>{{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:unitPrice="{ row }">
        <span>{{ row.unitPrice }} </span>
        <span>{{ row.fabricUnit }}</span>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_choice') || '选择'"
            placement="top"
          >
            <i class="el-icon-check tool-btn" @click="chooseAdd(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    tableData: {
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
          tools: 'tools',
        },
        zoom: false,
      },
      tableColumn: [
        { width: 60, fixed: 'left', type: 'checkbox', align: 'center' },
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'fabricColorNo',
          width: 200,
          title: this.$l('INDEX.label_fabric_color_number') || '库存编号',
        },
        {
          field: 'fabricColorTitle',
          width: 200,
          title: this.$l('INDEX.choose_fabric_color') || '面料颜色名称',
        },
        {
          field: 'stockQuantity',
          width: 100,
          title: this.$l('INDEX.label_inventory_quantity') || '库存数量',
        },
        {
          field: 'fabricName',
          minWidth: 350,
          title: this.$l('INDEX.choose_fabric_fabricName') || '面料名称',
          slots: {
            default: 'fabricName',
          },
        },
        {
          field: 'fabricContent',
          minWidth: 300,
          title: this.$l('INDEX.choose_fabric_content') || '面料成分',
          slots: {
            default: 'fabricContent',
          },
        },
        {
          field: 'wid',
          width: 120,
          title: this.$l('INDEX.choose_fabric_wid') || '门幅',
          slots: {
            default: 'wid',
          },
        },
        {
          field: 'fabricWeight',
          width: 120,
          title: this.$l('INDEX.choose_fabric_weight') || '克重',
          slots: {
            default: 'fabricWeight',
          },
        },
        {
          field: 'unitPrice',
          width: 120,
          title: this.$l('INDEX.choose_fabric_price') || '单价',
          slots: {
            default: 'unitPrice',
          },
        },
        {
          field: 'userNameEn',
          width: 150,
          title: this.$l('INDEX.choose_fabric_agent') || '业务员',
        },
        {
          field: 'supName',
          minWidth: 300,
          title: this.$l('INDEX.choose_fabric_supName') || '供应商',
        },
      ],
      showSelectCount: '请点击选择列表中记录',
      selectedCount: 0,
    }
  },
  methods: {
    selectAllEvent() {
      this.calculateSelected()
    },
    selectChangeEvent() {
      this.calculateSelected()
    },
    calculateSelected() {
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount > 0) {
        this.showSelectCount = '本次已选择【' + totCount + '】条'
      } else {
        this.showSelectCount = '请点击选择列表中记录'
      }
    },
    chooseCode() {
      let codeList = []
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择库存面料')
        return false
      }
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          codeList.push(row)
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          codeList.push(row)
        })
      }
      this.$emit('saveChooseCode', codeList)
    },
  },
}
</script>
<style lang="scss" scoped>
.fabric-tree {
  height: 550px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px; /*滚动条宽度*/
  }
}
</style>
